import { defineMessages } from 'react-intl';

export default defineMessages({
    searchHeader: {
        id: 'ml.quoteandbind.common.employeraffilitation.searchHeader',
        defaultMessage: 'You may choose to provide the following information to determine your eligibility for our group program.  For the best results, enter complete name or as many characters as possible.'
    },
    searchHeaderQnb: {
        id: 'ml.quoteandbind.common.employeraffilitation.searchHeaderQnb',
        defaultMessage: 'Start entering the name of your group. Click on the selection once it appears in the list of matching results.'
    },    
    searchHeaderNonServicingStates: {
        id: 'ml.quoteandbind.common.employeraffilitation.searchHeaderNonServicingStates',
        defaultMessage: 'You will be able to complete your quote even if you are unable to retrieve your employer or affiliation information.'
    },
    searchTooltipContent: {
        id: 'ml.quoteandbind.common.employeraffilitation.searchTooltipContent',
        defaultMessage: '<p>An affiliation is an organization you are a member of or a professional group you belong to. Employer can be your current employer or your employer prior to retirement.</p><p>Please be sure you are spelling the name correctly. If you recently received correspondence from MetLife Auto & Home, the correspondence may include the name of your affiliation/employer, please search using that name. In some cases, you may need to enter the name of your Benefits Administrator company instead of your employer’s name.</p><p>You will be able to complete your quote even if you are unable to retrieve your employer or affiliation information.</p>'
    },
    searchTooltipContentQb: {
        id: 'ml.quoteandbind.common.employeraffilitation.searchTooltipContentFarmers',
        defaultMessage: '<p>An affiliation is an organization you are a member of or a professional group you belong to. Employer can be your current employer or your employer prior to retirement.</p><p>Please be sure you are spelling the name correctly. If you recently received correspondence from Farmers, the correspondence may include the name of your affiliation/employer, please search using that name. In some cases, you may need to enter the name of your Benefits Administrator company instead of your employer’s name.</p><p>You will be able to complete your quote even if you are unable to retrieve your employer or affiliation information.</p>'
    },
    searchByGPCTooltipContent: {
        id: 'ml.quoteandbind.common.employeraffilitation.searchByGPCTooltipContent',
        defaultMessage: 'If you received marketing materials from us, the three character marketing code (GPC) can be found on that material.'
    },
    searchTooltipLabel: {
        id: 'ml.quoteandbind.common.employeraffilitation.searchTooltipLabel',
        defaultMessage: 'What should I enter?'
    },
    prefillMessage: {
        id: 'ml.quoteandbind.common.employeraffilitation.prefillMessage',
        defaultMessage: 'You could save money by providing your employer or affiliation name. Discounts can vary by state and are subject to availability.'
    },
    searchByEmployer: {
        id: 'ml.quoteandbind.common.employeraffilitation.searchByEmployer',
        defaultMessage: 'Search By Employer or Affiliation'
    },
    nameSearchPlaceholder: {
        id: 'ml.quoteandbind.common.employeraffilitation.nameSearchPlaceholder',
        defaultMessage: 'Start Typing'
    },
    searchButton: {
        id: 'ml.quoteandbind.common.employeraffilitation.searchButton',
        defaultMessage: 'Search'
    },
    updateSearchButton: {
        id: 'ml.quoteandbind.common.employeraffilitation.updateSearchButton',
        defaultMessage: 'Update Search Selection'
    },
    or: {
        id: 'ml.quoteandbind.common.employeraffilitation.or',
        defaultMessage: 'or '
    },
    searchByGPC: {
        id: 'ml.quoteandbind.common.employeraffilitation.searchByGPC',
        defaultMessage: 'Search By GPC/Paypoint'
    },
    paypointPlaceholder: {
        id: 'ml.quoteandbind.common.employeraffilitation.paypointPlaceholder',
        defaultMessage: 'Enter a Paypoint'
    },
    paypointFieldLabel: {
        id: 'ml.quoteandbind.common.employeraffilitation.paypointFieldLabel',
        defaultMessage: 'Enter Paypoint to filter results'
    },
    searchByMarketingCode: {
        id: 'ml.quoteandbind.common.employeraffilitation.searchByMarketingCode',
        defaultMessage: 'Search By Marketing Code'
    },
    searchByEmployerAffiliation: {
        id: 'ml.quoteandbind.common.employeraffilitation.searchByEmployerAffiliation',
        defaultMessage: 'Search By Employer/ Affiliation'
    },
    enter3CharacterGpc: {
        id: 'ml.quoteandbind.common.employeraffilitation.enter3CharacterGpc',
        defaultMessage: 'Enter a 3 character GPC'
    },
    enter3CharacterMarketingNonOptional: {
        id: 'ml.quoteandbind.common.employeraffilitation.enter3CharacterMarketingNonOptional',
        defaultMessage: 'Enter a 3 character code'
    },
    enter3CharacterMarketing: {
        id: 'ml.quoteandbind.common.employeraffilitation.enter3CharacterMarketing',
        defaultMessage: 'Enter a 3 character code (optional)'
    },
    optional: {
        id: 'ml.quoteandbind.common.employeraffilitation.optional',
        defaultMessage: 'optional'
    },
    errorOccuredTryAgain: {
        id: 'ml.quoteandbind.common.employeraffilitation.errorOccuredTryAgain',
        defaultMessage: 'An error occurred.  Please try your search again.'
    },
    showNoAvailableGroupError: {
        id: 'ml.quoteandbind.common.employeraffilitation.showNoAvailableGroupError',
        defaultMessage: 'The Group that you have searched for is not available in this state or line of business at this time, please update your search or contact us {phone} to check eligibility.'
    },
    multipleEntriesError: {
        id: 'ml.quoteandbind.common.employeraffilitation.multipleEntriesError',
        defaultMessage: 'Multiple entries match your selection, please narrow your search by entering additional characters in the search box'
    },
    removeSelection: {
        id: 'ml.quoteandbind.common.employeraffilitation.removeSelection',
        defaultMessage: 'Reset Group Information'
    },
    prefillHeader: {
        id: 'ml.quoteandbind.common.employeraffilitation.prefillHeader',
        defaultMessage: 'Agent Script'
    },
    noResultsFound: {
        id: 'ml.quoteandbind.common.employeraffilitation.noResultsFound',
        defaultMessage: 'The Group that you have searched for is not available in this state or line of business at this time, please update your search or contact us {phone} to check eligibility.'
    },
    cantFindEmployer: {
        id: 'ml.quoteandbind.common.employeraffilitation.cantFindEmployer',
        defaultMessage: 'Can\'t find your employer or affiliation?'
    },
    cantFindEmployerContent: {
        id: 'ml.quoteandbind.common.employeraffilitation.cantFindEmployerContent',
        defaultMessage: 'Your employer or affiliation may not be participating in our group discount program. If you believe this is in error, contact us for assistance.<p> This field is optional and you can continue with your quote by completing the remaining fields and clicking CONTINUE.</p>'
    },
    cantFindEmployerContentQb: {
        id: 'ml.quoteandbind.common.employeraffilitation.cantFindEmployerContentQb',
        defaultMessage: 'Your employer or affiliation may not be participating in our group discount program. If you believe this is in error, contact us for assistance.'
    },
    qnbUpdateSearchWarning: {
        id: 'ml.quoteandbind.common.employeraffilitation.qnbUpdateSearchWarning',
        defaultMessage: 'We have retrieved the below group affiliation information. Please review and if incorrect, update by clicking <b>EDIT</b> below.'
    },
    gpaUpdateSearchWarning: {
        id: 'ml.quoteandbind.common.employeraffilitation.gpaUpdateSearchWarning',
        defaultMessage: 'We have retrieved the below group affiliation information.  Please review.  If not correct, update the entry in the Search By box.'
    },
    mlPhoneNumber: {
        id: 'ml.quoteandbind.common.employeraffilitation.mlPhoneNumber',
        defaultMessage: '1-844-438-8430'
    },
    qnbSelectEmployerWarning: {
        id: 'ml.quoteandbind.common.employeraffilitation.qnbSelectEmployerWarning',
        defaultMessage: 'There may be multiple options for your listed Employer/Affiliation. Please choose the appropriate match for your situation.'
    },
    qnbGPCMissing: {
        id: "ml.quoteandbind.affiliation.qnbGPCMissing",
        defaultMessage: "Please enter an employer/gpc"
    },
    somethingWentWrong: {
        id: 'ml.quoteandbind.common.quote.somethingWentWrong',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    },
    invalidGpc: {
        id: "ml.quoteandbind.affiliation.invalidGpc",
        defaultMessage: "Invalid GPC for Agent ID"
    },
        invalidEmployerorAffiliation: {
        id: "ml.quoteandbind.affiliation.invalidEmployerorAffiliation",
        defaultMessage: "Invalid Employer/Affiliation for Agent ID"
    } 
});
